import { render } from "./GroupDetail.vue?vue&type=template&id=a9fe87c8&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"

import "./GroupDetail.vue?vue&type=style&index=0&id=a9fe87c8&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fe87c8"]])

export default __exports__